import React, { useState } from 'react';
import { APP_STORE_URL, PLAY_STORE_URL, openInApp } from './openInApp';

const WEB_CREATE_URL = 'https://web.jivebird.com/';

const STORE = {
  ios: { url: APP_STORE_URL, button: 'Download on the App Store' },
  android: { url: PLAY_STORE_URL, button: 'Download on Google Play' },
};

/**
 * "See More + Create a JiveBird" button for viewer.jivebird.com.
 * Phone: opens the JiveBird app on the builder, or shows an install popup.
 * Desktop: opens the website, as before.
 */
export default function SeeMoreButton({ onClick, className, style, children }) {
  const [platform, setPlatform] = useState(null);

  const handleClick = e => {
    e.preventDefault();
    onClick?.();
    const handled = openInApp('create', { onNotInstalled: setPlatform });
    if (!handled) window.open(WEB_CREATE_URL, '_blank', 'noopener,noreferrer');
  };

  return (
    <>
      <a
        href={WEB_CREATE_URL}
        target="_blank"
        rel="noopener noreferrer"
        className={className || "jb-banner-create-btn"}
        style={style}
        onClick={handleClick}>
        {children || "Create my FREE JiveBird & See More"}
      </a>
      {platform ? (
        <InstallPopup platform={platform} onClose={() => setPlatform(null)} />
      ) : null}
    </>
  );
}

function InstallPopup({ platform, onClose }) {
  const store = STORE[platform];
  if (!store) return null;

  return (
    <div style={styles.overlay} onClick={onClose} role="dialog" aria-modal="true">
      <div style={styles.card} onClick={e => e.stopPropagation()}>
        <button onClick={onClose} aria-label="Close" style={styles.close}>
          ×
        </button>
        <h2 style={styles.title}>Get the JiveBird App</h2>
        <p style={styles.text}>
          Personalised cards with song, voice, video &amp; eGift vouchers work
          best in our mobile app!
        </p>
        <a href={store.url} style={styles.primary}>
          {store.button}
        </a>
        <a
          href={WEB_CREATE_URL}
          target="_blank"
          rel="noopener noreferrer"
          onClick={onClose}
          style={styles.secondary}>
          Continue in web browser
        </a>
        <p style={styles.note}>Free to download • First 25 JiveBirds free</p>
      </div>
    </div>
  );
}

// Inline styles: the viewer site doesn't use Tailwind
const styles = {
  overlay: {
    position: 'fixed',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    inset: 0,
    zIndex: 2000,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 16,
    background: 'rgba(0,0,0,0.6)',
  },
  card: {
    position: 'relative',
    width: '100%',
    maxWidth: 360,
    padding: 24,
    borderRadius: 20,
    background: '#fff',
    textAlign: 'center',
    boxShadow: '0 20px 50px rgba(0,0,0,0.3)',
    fontFamily: 'inherit',
  },
  close: {
    position: 'absolute',
    top: 10,
    right: 10,
    width: 32,
    height: 32,
    border: 0,
    borderRadius: 16,
    background: 'rgba(0,0,0,0.08)',
    fontSize: 20,
    lineHeight: '32px',
    cursor: 'pointer',
  },
  title: { margin: '4px 0 8px', fontSize: 22, fontWeight: 800, color: '#1A1A74' },
  text: { margin: '0 0 18px', fontSize: 14, color: '#555' },
  primary: {
    display: 'block',
    padding: '13px 0',
    borderRadius: 14,
    background: '#FF3D00',
    color: '#fff',
    fontSize: 16,
    fontWeight: 800,
    textDecoration: 'none',
  },
  secondary: {
    display: 'block',
    marginTop: 10,
    padding: '11px 0',
    borderRadius: 14,
    border: '1px solid #ddd',
    color: '#1A1A1A',
    fontSize: 15,
    fontWeight: 700,
    textDecoration: 'none',
  },
  note: { margin: '12px 0 0', fontSize: 12, color: '#999' },
};
